import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent, tagEvents } from 'tag/ts/tag/events/TagEvent';
import { TagEventVO } from 'tag/ts/tag/events/TagEventVO';
import { AviaPlayerHooksManager } from 'tag/ts/tag/player/adapters/avia/hooks/AviaPlayerHooksManager';
import { AviaAPITransformer } from 'tag/ts/tag/player/adapters/avia/transformers/AviaAPITransformer';
import { AviaEventTransformer } from 'tag/ts/tag/player/adapters/avia/transformers/AviaEventTransformer';
export class AviaPlayerWrapper extends AbstractTagClass {
    #adaptedPlayerInstance;
    #aviaAPITransformer;
    #aviaEventTransformer;
    #aviaPlayerHooksManager;
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaPlayerWrapper'
        });
        this.#adaptedPlayerInstance = argument.aviaPlayerInstance;
        this.#aviaEventTransformer = new AviaEventTransformer({ tag: argument?.tag, aviaPlayerWrapper: this });
        this.#aviaAPITransformer = new AviaAPITransformer({ tag: argument?.tag, aviaPlayerWrapper: this, aviaEventTransformer: this.#aviaEventTransformer });
        this.#aviaPlayerHooksManager = new AviaPlayerHooksManager({ tag: argument?.tag, player: argument.aviaPlayerInstance });
        this.#aviaAPITransformer.addPlayerEventListener().then((data) => {
            this.tagEventsHandler(this.#onTagEvent, [
                TagEvent.ON_TAG_PLAYER_STOP_REQUEST
            ]);
        });
    }
    get adaptedPlayerInstance() {
        return this.#adaptedPlayerInstance;
    }
    set adaptedPlayerInstance(value) {
        this.#adaptedPlayerInstance = value;
    }
    get API() {
        return this.#aviaAPITransformer;
    }
    cleanUp = () => {
        const unsubscribeFromTagEvents = () => {
            return new Promise((resolve, reject) => {
                this.removeTagEventsHandler(this.#onTagEvent, this.tag.eventDispatcher, tagEvents()).then((data) => {
                    resolve({ msg: 'Unsubscribed from tag events.', success: true });
                });
            });
        };
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isFunction(this.#aviaAPITransformer?.removePlayerEventListener)) {
                this.#aviaAPITransformer.removePlayerEventListener().then((data) => {
                    const cleaningUpHooks = this.#aviaPlayerHooksManager?.cleanUp?.();
                    if (this.utils.Type.isNullOrUndefined(cleaningUpHooks)) {
                        this?.logger?.warn('hook cleanUp has already run', 'this.#aviaPlayerHooksManager', this.#aviaPlayerHooksManager, 'this.#aviaPlayerHooksManager?.cleanUp', this.#aviaPlayerHooksManager?.cleanUp);
                        resolve({ msg: 'Cleanup already done.', success: true });
                        return;
                    }
                    cleaningUpHooks.then((data) => {
                        this.#aviaPlayerHooksManager = undefined;
                        this.#adaptedPlayerInstance = undefined;
                        this.#aviaAPITransformer = undefined;
                        this.#aviaEventTransformer = undefined;
                        unsubscribeFromTagEvents().then((data) => {
                            resolve({ msg: 'Cleanup done.', success: true });
                        });
                    });
                });
            }
            else {
                unsubscribeFromTagEvents().then((data) => {
                    resolve({ msg: 'Cleanup done.', success: true });
                });
            }
        });
    };
    requestPlayerStop = (event = undefined) => {
        return new Promise((resolve, reject) => {
            const executeCallback = (success, result) => {
                if (this.utils.Type.isFunction(event?.data?.eventCallback) && this.utils.Type.isBoolean(success)) {
                    this.utils.Delay.delay()
                        .then(() => {
                        this?.logger?.log('requestPlayerStop:', 'execute event callback:', success, result);
                        event?.data?.eventCallback(success, result);
                    });
                }
            };
            if (this.utils.Type.isDefined(this?.API)) {
                this.dispatchTagEvent(new TagEventVO(TagEvent.ON_TAG_BEFORE_PLAYER_STOP_REQUEST, this.tag, undefined, this));
                this.API.stop().then((result) => {
                    this?.logger?.log('requestPlayerStop:', 'Success');
                    this.dispatchTagEvent(new TagEventVO(TagEvent.ON_TAG_PLAYER_STOP_SUCCESS, this.tag, undefined, this));
                    executeCallback(true, result);
                    resolve({ msg: 'done', result: result });
                }).catch((error) => {
                    this?.logger?.warn('requestPlayerStop:', 'Failure');
                    this.dispatchTagEvent(new TagEventVO(TagEvent.ON_TAG_PLAYER_STOP_FAILURE, this.tag, undefined, this));
                    executeCallback(false, error);
                    resolve({ msg: 'error', result: error });
                });
            }
        });
    };
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_TAG_PLAYER_STOP_REQUEST:
                if (!this.utils.Type.isEmpty(this?.adaptedPlayerInstance)) {
                    this.requestPlayerStop(event).then();
                }
                break;
        }
    };
}
